var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.$spa.css.layout.page_tabs.tab,attrs:{"to":{name: _vm.tab.name},"active-class":_vm.$spa.css.layout.page_tabs.tab_active}},[_vm._v("\n    "+_vm._s(_vm.tab.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }